// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  api_url: "https://abcgbtestebanka.gbkr.si/test-retail/admin/v1",
  api_key: "bGVvbnVzLWFkbWluOmxlb251cy1zZWNyZXQ=",
  // google_maps_api_key: 'AIzaSyBZFssgTOKaGIny5NFe5UxAHILdLjdFOUE'
  google_maps_api_key: "AIzaSyDqyH9A2F_u8daBBCSdepS5RBHoEDwRnZc",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
